export const GROUPING_CAP_TYPES = {
    UNLIMITED: {
        value: -1,
        label: 'Unlimited',
    },
    THREE: {
        value: 3,
        label: '3',
    },
    TWO: {
        value: 2,
        label: '2',
    },
    ONE: {
        value: 1,
        label: '1',
    },
    IGNORE: {
        value: 0,
        label: 'Ignore',
    },
}

export const GROUPING_CAP_TYPES_VALUE_TO_NAME = {
    [GROUPING_CAP_TYPES.UNLIMITED.value]: GROUPING_CAP_TYPES.UNLIMITED.label,
    [GROUPING_CAP_TYPES.THREE.value]: GROUPING_CAP_TYPES.THREE.label,
    [GROUPING_CAP_TYPES.TWO.value]: GROUPING_CAP_TYPES.TWO.label,
    [GROUPING_CAP_TYPES.ONE.value]: GROUPING_CAP_TYPES.ONE.label,
    [GROUPING_CAP_TYPES.IGNORE.value]: GROUPING_CAP_TYPES.IGNORE.label,
}
